import { Bindings, FormControl, RichEditor, ShopifyResourcePicker, Button, Alert, Icon, CustomText, ColorPicker, ButtonSelect, ImagePicker } from "components"
import PreviewContext from "context/PreviewContext";
import classNames from "lib/classNames";
import { GIFT_WITH_PURCHASE_PRODUCT_REDUCER } from "lib/globals";
import React, { Fragment, useContext, useState } from "react"
import { Toast } from '@shopify/app-bridge/actions';
import EmbeddedContext from "context/EmbeddedContext";
import imagePlaceholder from "assets/image_placeholder.png"
import { InitialSelectionIds } from "components/ShopifyResourcePicker";
import { SideBarBadge } from "components/Sidebar";

export default function Gift ({ context, index, validationErrors }) {
    const [current, setCurrentState] = useState("before")
    const { setGiftCurrentPreview } = useContext(PreviewContext)
    const { AppBridgeToast } = useContext(EmbeddedContext);
    const setCurrent = state => {
        setGiftCurrentPreview(state)
        setCurrentState(state)
    }
    const { goals } = context.state.settings.add_to_unlock
    const currentGoal = goals[index].gift
    const isRandom = currentGoal.multi_gift_select === "random"
    const previousGift = index > 0 ? goals[index - 1].reward_type === "gift" : false
    const hasMultipleGiftFeature = !!currentGoal.products //((currentGoal.products || []).concat([currentGoal.product]).filter(Boolean)).length > 1
    const hasMoreThanOneGift = currentGoal.products?.length > 1
    return (
        <Fragment>
            {!hasMultipleGiftFeature && <FormControl
                label="Select free gift"
                error={
                    validationErrors[`settings.add_to_unlock.goals.${index}.gift.product`]
                }
                info="Select the gift you would like to offer when goal is unlocked."
                isSingleCol
            >
                <ShopifyResourcePicker
                    allowMultiple={false}
                    initialQuery="product_type:free_gift"
                    reducer={GIFT_WITH_PURCHASE_PRODUCT_REDUCER}
                    verifySelection={([{ productType }]) => {
                        const isGift = productType.toLowerCase() === "free_gift"
                        if (!isGift) {
                            AppBridgeToast({
                                message: 'Select products with type: free_gift',
                                isError: true
                            }).open()
                        }
                        return isGift
                    }}
                    BindToContext={[context, `settings.add_to_unlock.goals.${index}.gift.product`]}
                >
                    {(trigger) => (
                        <Button
                            className={classNames("w-full mt-3")}
                            text="Select a free product"
                            type={
                                validationErrors[
                                    `settings.add_to_unlock.goals.${index}.gift.product`
                                ] &&
                                    !!validationErrors[
                                    `settings.add_to_unlock.goals.${index}.gift.product`
                                    ][0]
                                    ? "danger"
                                    : "primary"
                            }
                            onClick={trigger}
                        />
                    )}
                </ShopifyResourcePicker>
            </FormControl>}
            {
                hasMultipleGiftFeature && <FormControl
                    label="Select free gifts"
                    error={
                        validationErrors[`settings.add_to_unlock.goals.${index}.gift.products`]
                    }
                    info="Select the gifts you would like to offer when goal is unlocked. You can select multiple products however only 1 will be rewarded to customer."
                    isSingleCol
                >
                    <ShopifyResourcePicker
                        allowMultiple={hasMultipleGiftFeature}
                        initialSelectionIds={hasMultipleGiftFeature ? InitialSelectionIds(currentGoal.products, "gid://shopify/Product/{id}") : undefined}
                        initialQuery="product_type:free_gift"
                        reducer={GIFT_WITH_PURCHASE_PRODUCT_REDUCER}
                        verifySelection={(selection) => {
                            const hasNoGiftProduct = selection.find(({ productType }) => productType.toLowerCase() !== "free_gift")
                            if (hasNoGiftProduct) {
                                AppBridgeToast({
                                    message: 'Select products with type: free_gift',
                                    isError: true
                                }).open()
                                return false
                            }
                            return true
                        }}
                        BindToContext={[context, `settings.add_to_unlock.goals.${index}.gift.products`]}
                    >
                        {(trigger) => (
                            <Button
                                className={classNames("w-full mt-3")}
                                text="Select Free Products"
                                type={
                                    validationErrors[
                                        `settings.add_to_unlock.goals.${index}.gift.product`
                                    ] &&
                                        !!validationErrors[
                                        `settings.add_to_unlock.goals.${index}.gift.product`
                                        ][0]
                                        ? "danger"
                                        : "primary"
                                }
                                onClick={trigger}
                            />
                        )}
                    </ShopifyResourcePicker>
                </FormControl>
            }
            <Alert
                {...{
                    type: 'warning',
                    borderPosition: 'border-l-4',
                    iconSize: '2x',
                    title: 'Free Gift Products Must Be Created Within Shopify With Product Type: free_gift.',
                    icon: 'exclamation-circle',
                    customStyle: {
                        icon: 'text-orange-400 self-start mt-1',
                    }
                }}
                className="my-6 z-5"
            >
                <p>This campaign will not discount products for you. It will add a $0 product you created within shopify. We suggest hiding $0 products from your site search.</p>
                <div className={classNames('flex space-x-3 pt-3 justify-start')}>
                    <a
                        className={classNames(
                            'text-gray-800 text-sm flex items-center hover:text-orange-500 focus:outline-none focus:outline-shadow font-semibold py-1 px-2 uppercase border bg-orange-200 bg-opacity-50 border-orange-300 rounded'
                        )}
                        href="https://monsterapps.crisp.help/en/article/gift-with-purchase-setup-qt2dwa/"
                        target="_blank"
                    >
                        <Icon icon="info-circle" className="mr-2" size="1x" />
                        <span className={classNames('text-xs')}>Learn to make free gift product</span>
                    </a>
                </div>
            </Alert>
            {
                previousGift &&
                <FormControl error={validationErrors[`settings.add_to_unlock.goals.${index}.gift.previous_gift`]}>
                    <ButtonSelect
                        options={[
                            {
                                value: "keep",
                                label: "Keep previous gift",
                                info: "Previous unlocked gifts will stay in the cart"
                            },
                            {
                                value: "remove",
                                label: "Remove previous gift",
                                info: "Previously unlocked gifts will be replaced by this gift",
                                beta: true
                            }
                        ]}
                        BindToContext={[context, `settings.add_to_unlock.goals.${index}.gift.previous_gift`]} />
                </FormControl>
            }
            {
                hasMoreThanOneGift &&
                <FormControl error={validationErrors[`settings.add_to_unlock.goals.${index}.gift.multi_gift_select`]}>
                    <ButtonSelect
                        options={[
                            {
                                value: "select",
                                label: "Customer choose gift",
                                info: "Give a choice of free products when cart goals are met"
                            },
                            {
                                value: "random",
                                label: "Select random gift",
                                info: "Reward random gift from select products when cart goals are met",
                                beta: true
                            }
                        ]}
                        BindToContext={[context, `settings.add_to_unlock.goals.${index}.gift.multi_gift_select`]} />
                </FormControl>
            }
            <FormControl
                label="text before hitting the goal"
                info="We recommend using emoji's to draw attention"
                // error={validationErrors['settings.add_to_unlock.free_shipping.before']}
                isSingleCol
            >
                <RichEditor
                    imageEmoji={true}
                    BindToContext={[
                        context,
                        `settings.add_to_unlock.goals.${index}.gift.before`
                    ]}
                    placeholder="add {{amount}} to unlock free shipping !"
                // hasError={!!validationErrors['settings.add_to_unlock.free_shipping.before']}
                />
                <Bindings only={["goal", "amount_left"]} />
            </FormControl>
            <FormControl
                label="text after hitting the goal"
                info="We recommend using emoji's to draw attention. (You can leave this blank.)"
                // error={validationErrors['settings.add_to_unlock.discount.after']}
                isSingleCol
            >
                <RichEditor
                    imageEmoji={true}
                    BindToContext={[
                        context,
                        `settings.add_to_unlock.goals.${index}.gift.after`
                    ]}
                    placeholder="you've unlocked a Free Gift"
                />
            </FormControl>
            <FormControl
                label="Unlock Widget"
                isSingleCol
                withSwitch={[context, `settings.add_to_unlock.goals.${index}.gift.widget.active`]}
            />
            <div className={classNames({
                "hidden": !context.state.settings.add_to_unlock.goals[index].gift.widget.active
            })}>
                <CustomText
                    context={context}
                    label="Compare at price"
                    path={`settings.add_to_unlock.goals.${index}.gift.widget.compare_at_price`}
                    hasColor={true}
                    isSingleCol
                    bindings={{
                        custom: ["compare_at_price", "compare at price"]
                    }}
                    withSwitch={[context, `settings.add_to_unlock.goals.${index}.gift.widget.compare_at_price_active`]}
                />

                <FormControl label="Design gift widget" info="select gift will appear when gift uses variants or customer needs to choose from multiple gifts">
                    <div>
                        <div className={classNames("flex-center pt-5")}>
                            <button className={classNames("text-sm focus:outline-none py-2 px-3 font-semibold border-2 rounded-l border-r-none border-blue-500", {
                                "bg-blue-500 text-white": current === "before",
                                "bg-white text-blue-500": current !== "before",
                            })} onClick={() => setCurrent("before")}>Before hitting the goal</button>
                            {hasMultipleGiftFeature && !isRandom &&
                                <button className={classNames("relative text-sm focus:outline-none py-2 px-3 font-semibold border-t-2 border-b-2 border-blue-500", {
                                    "bg-blue-500 text-white": current === "selecting",
                                    "bg-white text-blue-500": current !== "selecting",
                                })} onClick={() => setCurrent("selecting")}>Selecting gift
                                    <span className={classNames('absolute flex-center bg-orange-500 tracking-wider py-1 px-2 rounded-lg text-white text-xxs font-bold')} style={{ top: -14, right: 5 }}>Beta</span>
                                </button>
                            }
                            <button className={classNames("text-sm focus:outline-none py-2 px-3 font-semibold border-2 rounded-r border-l-none border-blue-500", {
                                "bg-blue-500 text-white": current === "after",
                                "bg-white text-blue-500": current !== "after",
                            })} onClick={() => setCurrent("after")}>After hitting the goal</button>
                        </div>
                        <div className={classNames("py-5")}>
                            <div className={classNames({ "hidden": current !== "before" })}>
                                {hasMoreThanOneGift &&
                                    <FormControl
                                        label="Gift image"
                                        isSingleCol
                                    >
                                        <ImagePicker
                                            simplified
                                            value={context.state.settings.add_to_unlock.goals[index].gift.widget.before.multi_gift_image}
                                            onChange={(value) => {
                                                context.setItem(`settings.add_to_unlock.goals.${index}.gift.widget.before.multi_gift_image`, value)
                                            }}
                                        />
                                    </FormControl>
                                }
                                <FormControl
                                    label="header"
                                    info="We recommend using emoji's to draw attention"
                                    isSingleCol
                                >
                                    <RichEditor
                                        imageEmoji={true}
                                        BindToContext={[
                                            context,
                                            `settings.add_to_unlock.goals.${index}.gift.widget.before.header`
                                        ]}
                                        placeholder="Spend {{goal}} Get A Free Gift"
                                    />
                                    <Bindings only={["goal", "amount_left"]} />
                                </FormControl>
                                <FormControl
                                    label="Product name" isSingleCol>
                                    <RichEditor
                                        imageEmoji={true}
                                        BindToContext={[
                                            context,
                                            `settings.add_to_unlock.goals.${index}.gift.widget.before.product_name`
                                        ]}
                                        placeholder="Free Gift: {{product_name}}"
                                    // hasError={!!validationErrors['settings.add_to_unlock.free_shipping.before']}
                                    />
                                    {!hasMoreThanOneGift && <Bindings custom={["product_name", "product name"]} />}
                                </FormControl>
                                <CustomText
                                    context={context}
                                    label="Offer Highlight"
                                    path={`settings.add_to_unlock.goals.${index}.gift.widget.before.offer_highlight`}
                                    hasColor
                                />
                                <FormControl
                                    label="Design"
                                >
                                    <ColorPicker
                                        text="Background"
                                        BindToContext={[context, `settings.add_to_unlock.goals.${index}.gift.widget.before.background`]}
                                    />
                                    <ColorPicker
                                        text="Outline"
                                        BindToContext={[context, `settings.add_to_unlock.goals.${index}.gift.widget.before.outline`]}
                                    />
                                </FormControl>
                                {/* {!hasMultipleGiftProducts && <Fragment>
                                <CustomText
                                    context={context}
                                    label="Variant picker options"
                                    info="This will appear if free product has variants. (color, sizing ect.)"
                                    path={`settings.add_to_unlock.goals.${index}.gift.widget.before.variant_selector_text`}
                                    hasColor
                                />
                                <FormControl>
                                    <ColorPicker
                                        text="Button background"
                                        BindToContext={[context, `settings.add_to_unlock.goals.${index}.gift.widget.before.variant_button_background`]}
                                    />
                                </FormControl>
                            </Fragment>} */}
                            </div>
                            {hasMultipleGiftFeature && <div className={classNames({ "hidden": current !== "selecting" })}>
                                <FormControl
                                    label="header"
                                    info="We recommend using emoji's to draw attention"
                                    isSingleCol
                                >
                                    <RichEditor
                                        imageEmoji={true}
                                        BindToContext={[
                                            context,
                                            `settings.add_to_unlock.goals.${index}.gift.widget.selecting.header`
                                        ]}
                                        placeholder="Spend {{goal}} Get A Free Gift"
                                    />
                                    <Bindings only={["goal", "amount_left"]} />
                                </FormControl>
                                <FormControl
                                    label="Product name" isSingleCol>
                                    <RichEditor
                                        imageEmoji={true}
                                        BindToContext={[
                                            context,
                                            `settings.add_to_unlock.goals.${index}.gift.widget.selecting.product_name`
                                        ]}
                                        placeholder="Free Gift: {{product_name}}"
                                    // hasError={!!validationErrors['settings.add_to_unlock.free_shipping.selecting']}
                                    />
                                    <Bindings custom={["product_name", "product name"]} />
                                </FormControl>
                                <CustomText
                                    context={context}
                                    label="Offer Highlight"
                                    path={`settings.add_to_unlock.goals.${index}.gift.widget.selecting.offer_highlight`}
                                    hasColor
                                />
                                <CustomText
                                    context={context}
                                    label="Add to cart button"
                                    path={`settings.add_to_unlock.goals.${index}.gift.widget.selecting.variant_selector_text`}
                                    hasColor
                                    beta
                                />
                                <FormControl
                                    label="Design"
                                >
                                    <ColorPicker
                                        text="Background"
                                        BindToContext={[context, `settings.add_to_unlock.goals.${index}.gift.widget.selecting.background`]}
                                    />
                                    <ColorPicker
                                        text="Outline"
                                        BindToContext={[context, `settings.add_to_unlock.goals.${index}.gift.widget.selecting.outline`]}
                                    />
                                    <ColorPicker
                                        text="Add to cart button background"
                                        BindToContext={[context, `settings.add_to_unlock.goals.${index}.gift.widget.selecting.variant_button_background`]}
                                    />
                                </FormControl>
                            </div>}
                            <div className={classNames({ "hidden": current !== "after" })}>
                                <FormControl
                                    label="header"
                                    info="We recommend using emoji's to draw attention"
                                    // error={validationErrors['settings.add_to_unlock.free_shipping.before']}
                                    isSingleCol
                                >
                                    <RichEditor
                                        imageEmoji={true}
                                        BindToContext={[
                                            context,
                                            `settings.add_to_unlock.goals.${index}.gift.widget.after.header`
                                        ]}
                                        placeholder="Spend {{goal}} Get A Free Gift"
                                    // hasError={!!validationErrors['settings.add_to_unlock.free_shipping.before']}
                                    />
                                </FormControl>
                                <FormControl
                                    label="Product name" isSingleCol>
                                    <RichEditor
                                        imageEmoji={true}
                                        BindToContext={[
                                            context,
                                            `settings.add_to_unlock.goals.${index}.gift.widget.after.product_name`
                                        ]}
                                        placeholder="Free Gift: {{product_name}}"
                                    // hasError={!!validationErrors['settings.add_to_unlock.free_shipping.before']}
                                    />
                                    <Bindings custom={["product_name", "product name"]} />
                                </FormControl>
                                <CustomText
                                    context={context}
                                    label="Offer Highlight"
                                    path={`settings.add_to_unlock.goals.${index}.gift.widget.after.offer_highlight`}
                                    hasColor={true}
                                />
                                <FormControl
                                    label="Design"
                                >
                                    <ColorPicker
                                        text="Background"
                                        BindToContext={[context, `settings.add_to_unlock.goals.${index}.gift.widget.after.background`]}
                                    />
                                    <ColorPicker
                                        text="Outline"
                                        BindToContext={[context, `settings.add_to_unlock.goals.${index}.gift.widget.after.outline`]}
                                    />
                                    {/* <ColorPicker
                                text="Tick"
                                BindToContext={[context, `settings.add_to_unlock.goals.${index}.gift.widget.after.tick`]}
                            /> */}
                                </FormControl>
                                <CustomText
                                    context={context}
                                    beta
                                    label="Change to other gift"
                                    path={`settings.add_to_unlock.goals.${index}.gift.widget.after.variant_change_text`}
                                    hasColor={true}
                                />
                            </div>
                        </div>
                    </div>
                </FormControl>
                {/* <FormControl label="Show inventory amount left" info="When inventory is zero reward will be hidden" withSwitch={[context, `settings.add_to_unlock.goals.${index}.gift.inventory_quantity.active`]}>
                    <RichEditor
                        imageEmoji={true}
                        BindToContext={[
                            context,
                            `settings.add_to_unlock.goals.${index}.gift.inventory_quantity.text`
                        ]}
                        placeholder="Only {{inventory_quantity}} left"
                    />
                </FormControl> */}
            </div>
        </Fragment >
    )
}

